export enum ENewDashletTabs {
  SIMPLE_DASHLETS = 'simpleDashlets',
  ADVANCED_DASHLETS = 'advancedDashlets',
}
